import { db } from '../dbConfigs';
import { fileService } from './file.service';
import { helps } from 'src/_helpers';

export const docsService = {
    getAll,
    add,
    getById,
    update,
    updateField,
    _delete,
    uploadDocs,
    getAllCat,
    addCat,
    getCatById,
    updateCat,
    updateFieldCat,
    _deleteCat,
};

async function getAll(params = {}) {
    var ref = db.collection('docs');
    var _query = {};
    if (!helps.isEmpty(params)) {
        if (!helps.isEmpty(params.year)) {
            _query = ref.where('year', '==', params.year)
                .orderBy('create_date', 'desc');
        }
    } else {
        _query = ref.orderBy('create_date', 'desc');
    }
    const snapshot = await _query.get();
    const docs = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
    }));

    if (docs && docs.length > 0) {
        Promise.all(
            docs.map(async (_doc) => {
                if (_doc.create_date) {
                    var _date = _doc['create_date'];
                    _doc['create_date'] = _date.toDate();
                }
                if (_doc.start_date) {
                    var _date = _doc['start_date'];
                    _doc['start_date'] = _date.toDate();
                }
            })
        );
    }

    return docs;
}

async function getById(id) {
    try {
        const _doc = await db.collection("docs").doc(id)
            .get();
        if (_doc.exists) {
            return _doc.data();
        } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
        }
    } catch (error) {
        console.log("Error getting document:", error);
    }
}

async function add(_doc) {
    try {
        const docRef = await db.collection("docs").add(_doc);
        _doc.id = docRef.id;
        //console.log(_doc)
        update(_doc);
        console.log("Firebase: doc has been added successfully!");
        return _doc;
    } catch (error) {
        console.error("Error adding doc: ", error);
    }
}

async function update(_doc) {
    //console.log(doc);
    let dbRef = db.collection("docs").doc(_doc['id']);

    try {
        //console.log(doc);
        await dbRef.update(_doc).then(() => {
            console.log("Firebase: doc has been updated successfully!");
        });

        return _doc;
    } catch (error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
        return error;
    }
}

async function updateField(_doc, field) {
    //console.log(doc);
    let dbRef = db.collection("docs").doc(_doc['id']);

    try {
        console.log(field, _doc[field]);
        await dbRef.update({
            [field]: _doc[field]
        }).then(() => {
            console.log("Firebase: doc field has been updated successfully!");
        });

        return _doc;
    } catch (error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
        return error;
    }
}

async function _delete(_doc) {
    try {
        await db.collection("docs").doc(_doc.id).delete().then((_doc) => {
            return _doc;
        });
    } catch (error) {
        console.error("Error: ", error);
    }
}

async function uploadDocs(_doc, upload_files, object, object_id, user) {
    try {
        let old_attachment = _doc.attachment;
        if (!helps.isEmpty(upload_files)) {
            var _files = [];
            var _attachment = [];
            _files = await fileService.uploadFile(upload_files, object, object_id, user);
            if (!helps.isEmpty(_files) && _files.length > 0) {
                _files.map((file) => {
                    let _file = {
                        name: file.name,
                        url: file.url,
                    }
                    _attachment.push(_file);
                })
            }
            _doc['attachment'] = _attachment;
            updateField(_doc, 'attachment');
            console.log("Firebase: Doc attachment has been added successfully!");

            if (!helps.isEmpty(old_attachment)) {
                old_attachment.map((_file) => {
                    _file['object'] = object;
                    _file['object_id'] = object_id;
                    fileService.deleteFile(_file);
                });
            }
        }
        return _doc;
    } catch (error) {
        console.error("Error uploading asset attachment: ", error);
    }
}


// Categories 
async function getAllCat() {
    var ref = db.collection('docs_categories');
    var query = ref.orderBy('code', 'asc');
    const snapshot = await query.get();
    const cats = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
    }));
    if (cats && cats.length > 0) {
        Promise.all(
            cats.map(async (cat) => {
                if (cat.create_date) {
                    var _date = cat['create_date'];
                    cat['create_date'] = _date.toDate();
                }
            })
        );
    }
    return cats;
}

async function getCatById(id) {
    try {
        const doc = await db.collection("docs_categories").doc(id)
            .get();
        if (doc.exists) {
            return doc.data();
        } else {
            // doc.data() will be undefined in this case
            console.log("No such category!");
        }
    } catch (error) {
        console.log("Error getting category:", error);
    }
}

async function addCat(cat) {
    try {
        const docRef = await db.collection("docs_categories").add(cat);
        cat.id = docRef.id;
        updateCat(cat);
        console.log("Firebase: category has been added successfully!");
        return cat;
    } catch (error) {
        console.error("Error adding category: ", error);
    }
}

async function updateCat(cat) {
    //console.log(doc);
    let dbRef = db.collection("docs_categories").doc(cat['id']);

    try {
        //console.log(doc);
        await dbRef.update(cat).then(() => {
            console.log("Firebase: category has been updated successfully!");
        });

        return cat;
    } catch (error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
        return error;
    }
}

async function updateFieldCat(cat, field) {
    let dbRef = db.collection("docs_categories").doc(cat['id']);

    try {
        await dbRef.update({
            [field]: cat[field]
        }).then(() => {
            console.log("Firebase: category field has been updated successfully!");
        });

        return cat;
    } catch (error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
        return error;
    }
}

async function _deleteCat(cat) {
    try {
        await db.collection("docs_categories").doc(cat.id).delete().then((cat) => {
            return cat;
        });
    } catch (error) {
        console.error("Error: ", error);
    }
}
